import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "pop_up_layer",
      style: {"display":"block"},
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.fnEvent && $setup.fnEvent(...args)))
    }),
    _createElementVNode("div", {
      class: _normalizeClass(["pop_up _iframe", { mobile: $setup.state.isMobile }]),
      style: {"display":"block"}
    }, [
      _createElementVNode("button", {
        class: "close_btn icon_wrap",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.fnEvent && $setup.fnEvent(...args)))
      }, [...(_cache[3] || (_cache[3] = [
        _createElementVNode("img", {
          src: "img/close.png",
          alt: "닫기"
        }, null, -1)
      ]))]),
      _withDirectives(_createElementVNode("iframe", {
        src: $setup.props.url,
        onLoad: _cache[2] || (_cache[2] = ($event: any) => ($setup.state.isLoading = false))
      }, null, 40, _hoisted_1), [
        [_vShow, !$setup.state.isLoading]
      ]),
      ($setup.state.isLoading)
        ? (_openBlock(), _createBlock(_component_Spinner, { key: 0 }))
        : _createCommentVNode("", true)
    ], 2)
  ], 64))
}